export enum PageInformationInputNames {
  TITLE = 'title',
  STORY = 'story',
  NOTES = 'specialNotes',
}
